import { useState, useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useWeeklyOne } from '@/features/weekly-one/WeeklyOneContext';

export default function WeeklyOneReviewModal() {
  const { needsLastWeekReview, lastWeekCommitment, resolveLastWeekCommitment } = useWeeklyOne();
  const [saving, setSaving] = useState(false);
  const isSubmitting = useRef(false);

  const resolve = async (outcome: 'completed' | 'missed') => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setSaving(true);
    try {
      await resolveLastWeekCommitment(outcome);
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      isSubmitting.current = false;
      setSaving(false);
    }
  };

  return (
    <Dialog open={needsLastWeekReview} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-sm"
        onInteractOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-lg">Quick check-in on last week</DialogTitle>
        </DialogHeader>

        <div className="pt-1 space-y-4">
          <p className="text-sm text-muted-foreground">
            You set a Weekly One last week. Did you follow through?
          </p>

          {lastWeekCommitment?.commitment_text && (
            <p className="text-sm text-foreground italic border-l-2 border-border pl-3">
              "{lastWeekCommitment.commitment_text}"
            </p>
          )}

          <div className="flex justify-end gap-2 pt-1">
            <Button
              variant="outline"
              size="sm"
              disabled={saving}
              onClick={() => resolve('missed')}
            >
              Not this week
            </Button>
            <Button
              size="sm"
              disabled={saving}
              onClick={() => resolve('completed')}
              className="text-white font-medium"
              style={{ background: '#1D9E75' }}
            >
              {saving ? 'Saving...' : 'Yes, complete!'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
